import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, Loader2, ArrowLeft, CheckCircle2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { AuthScene, AuthCard, AuthInput } from "@/pages/Login";

export default function ForgotPassword() {
  const { forgotPassword } = useAuth();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await forgotPassword(email.trim());
      setSent(true);
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthScene>
      <div className="fh-eyebrow" style={{ color: "#FFE066" }}>
        Forgot password
      </div>
      <h1 className="fh-heading" style={{ fontSize: "clamp(2rem, 4vw, 2.75rem)" }}>
        Reset your password
      </h1>
      <p className="fh-text" style={{ maxWidth: "44ch" }}>
        Enter your email and we'll send you a secure link to set a new password.
      </p>

      <AuthCard>
        {sent ? (
          <div className="text-white/90 text-sm" data-testid="forgot-sent">
            <CheckCircle2 className="h-5 w-5 text-amber-300 inline mr-2" />
            If that email belongs to an active account, a reset link is on its way.
            Check your inbox.
            <div className="mt-4">
              <Link to="/login" className="text-amber-300 underline-offset-4 hover:underline">
                <ArrowLeft className="h-4 w-4 inline mr-1" /> Back to sign in
              </Link>
            </div>
          </div>
        ) : (
          <form onSubmit={submit}>
            <AuthInput
              label="Email"
              type="email"
              value={email}
              onChange={setEmail}
              placeholder="you@company.com"
              icon={<Mail className="h-4 w-4" />}
              testId="forgot-email"
              autoFocus
              autoComplete="email"
            />
            <button type="submit" disabled={busy} className="fh-btn-primary w-full" data-testid="forgot-submit">
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Mail className="h-4 w-4" />}
              {busy ? "Sending…" : "Send reset link"}
            </button>
            <div className="mt-4 text-xs">
              <Link to="/login" className="text-white/70 hover:text-amber-300 underline-offset-4 hover:underline">
                <ArrowLeft className="h-3.5 w-3.5 inline mr-1" /> Back to sign in
              </Link>
            </div>
          </form>
        )}
      </AuthCard>
    </AuthScene>
  );
}
